import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=5293057f&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=5293057f&prod&scoped=true&lang=css"
import style1 from "./Tags.vue?vue&type=style&index=1&id=5293057f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293057f",
  null
  
)

export default component.exports